var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJobSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Image",
    transform: "translate(-17.576 3.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Controls-Icon-Search",
    transform: "translate(25.576 -0.001)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2254",
    "data-name": "Rectangle 2254",
    width: 68,
    height: 68,
    fill: "#0098db",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2934",
    "data-name": "Path 2934",
    d: "M77.384,72.181l-7.346-7.347-8.97-8.971a26.347,26.347,0,1,0-4.963,4.961L72.423,77.142a3.508,3.508,0,0,0,4.961-4.961Zm-58.379-32.2A21.223,21.223,0,1,1,40.23,61.21,21.248,21.248,0,0,1,19.005,39.986Z",
    transform: "translate(-12.203 -11.961)",
    fill: "#0098db"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3677",
    "data-name": "Group 3677",
    transform: "translate(17.576 -3.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1869",
    "data-name": "Path 1869",
    d: "M688.863,182.249s-.786,6.285-.589,6.678c.074.149-.145,2.04-1.021,1.23-1.36-1.258-3.693-5.551-3.693-5.551s1.768-2.75,1.375-4.125Z",
    transform: "translate(-670.085 -173.026)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_561",
    "data-name": "Ellipse 561",
    cx: 15.5,
    cy: 2.345,
    rx: 15.5,
    ry: 2.345,
    transform: "translate(0 70.31)",
    fill: "#6639b7",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4146",
    "data-name": "Path 4146",
    d: "M676.228,736.392s1.964.589,2.357,1.375,6.874,2.161,4.91,3.143-7.856-.786-7.856-.786-3.143-.2-2.946-1.375a11.644,11.644,0,0,1,.912-2.63Z",
    transform: "translate(-658.977 -668.827)",
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1881",
    "data-name": "Path 1881",
    d: "M631.98,719.378s1.964.589,2.357,1.375,6.874,2.16,4.91,3.143-7.856-.786-7.856-.786-3.143-.2-2.946-1.375a11.644,11.644,0,0,1,.912-2.63Z",
    transform: "translate(-614.763 -652.075)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1883",
    "data-name": "Path 1883",
    d: "M676.228,736.392s1.964.589,2.357,1.375,6.874,2.161,4.91,3.143-7.856-.786-7.856-.786-3.143-.2-2.946-1.375a11.644,11.644,0,0,1,.912-2.63Z",
    transform: "translate(-664.783 -666.602)",
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1882",
    "data-name": "Path 1882",
    d: "M676.228,736.392s1.964.589,2.357,1.375,6.874,2.161,4.91,3.143-7.856-.786-7.856-.786-3.143-.2-2.946-1.375a11.644,11.644,0,0,1,.912-2.63Z",
    transform: "translate(-664.783 -666.975)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1885",
    "data-name": "Path 1885",
    d: "M-1926.153,6077.12a2.4,2.4,0,0,0-1.484-.431,2.813,2.813,0,0,0-1.584.873c-.066.112-.707-1-.707-1l2.087-.337,1.782.125v.628Z",
    transform: "translate(1938.816 -6007.127)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1886",
    "data-name": "Path 1886",
    d: "M-1928.025,6076.705a5.121,5.121,0,0,0-1.843.4l-.059-.283.124-.6h1.778l1.782.125v.676A4.74,4.74,0,0,0-1928.025,6076.705Z",
    transform: "translate(1944.688 -6009.24)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1866",
    "data-name": "Path 1866",
    d: "M751.883,245.665l-3.143-.393a17.873,17.873,0,0,0-1.953,5.194,1.923,1.923,0,0,0,.7,1.853C749.255,253.3,751.883,245.665,751.883,245.665Z",
    transform: "translate(-742.249 -229.473)",
    fill: "#522680"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1868",
    "data-name": "Path 1868",
    d: "M578.61,275.3s-.982,12.767.393,13.159,6.285,3.339,14.141,2.553c0,0,7.66,4.125,6.482.2s-6.482-2.946-6.482-2.946-9.428-1.964-9.82-3.339,1.178-7.071.589-7.267S578.61,275.3,578.61,275.3Z",
    transform: "translate(-569.296 -258.248)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1876",
    "data-name": "Path 1876",
    d: "M592.159,373.334h0l-2.637-.611a.575.575,0,0,0-.648.311l-2.7,5.6a.465.465,0,0,0,.292.649l2.68.761a.614.614,0,0,0,.732-.348l1.724-4,.052.029.328-.759-.055-.028.481-1.118a.354.354,0,0,0-.248-.486Z",
    transform: "translate(-562.96 -344.442)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1877",
    "data-name": "Path 1877",
    d: "M591.755,373.925l-.308-.071a.4.4,0,0,0-.449.217l-2.637,5.566a.247.247,0,0,0,.151.341l2.661.8a.319.319,0,0,0,.385-.18l2.495-5.807a.28.28,0,0,0-.194-.383l-.292-.068a.132.132,0,0,0-.146.066h0a.116.116,0,0,1-.129.059l-1.386-.321A.2.2,0,0,1,591.755,373.925Z",
    transform: "translate(-564.875 -345.433)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1873",
    "data-name": "Path 1873",
    d: "M662.737,445.62s-.875,19.534-2.13,22.283a25.414,25.414,0,0,0-.962,5.052c-.156,1.083-.418,2.028-.534,3.129-.023.223-.571,1.065-.6,1.319-.068.684.4.715.346,1.33-.049.579-.09,1.109-.118,1.5a5.229,5.229,0,0,0-1.925-.374c-.884.1-1.913.41-1.9.374-.051-.191-.1-.136,0-.945.032-.267.232-.346.252-.756.015-.295.009-.722,0-1.133-.012-.542-.036-1.157-.067-1.851-.021-.484.3-.787.277-1.345-.015-.339-.378-.926-.392-1.3a20.422,20.422,0,0,1,.183-5.005c.836-2.75-1.929-21.932-1.929-21.932Z",
    transform: "translate(-640.328 -412.581)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1887",
    "data-name": "Path 1887",
    d: "M29.421,50.946c.054.137.211.63.476,1.187a2.415,2.415,0,0,0,.956,1.071,3.818,3.818,0,0,0,2.013.723,1.565,1.565,0,0,0,.967-.262c.929-.589-.157-2.217-.114-2.269S29.271,50.57,29.421,50.946Z",
    transform: "translate(-15.259 -42.908)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1870",
    "data-name": "Path 1870",
    d: "M-1363.209,5553.848l-1.12,2.836-3.4-4.98-.075.172-.241,6.557h6.6l-1.764-4.256Z",
    transform: "translate(1381.443 -5540.678)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1884",
    "data-name": "Path 1884",
    d: "M807.5,560.883a3.574,3.574,0,0,1,.194.653,7.477,7.477,0,0,1,.088,1.854c-.047.891,0,6.864,0,6.864s.278,1.681.424,2.154a5.384,5.384,0,0,1,0,1.57c-.255,1.453,1.289,3.093,1.289,3.093,1.569-1.9,3.028-.436,3.028-.436a3.012,3.012,0,0,0,.627-.987c.257-.637.444-2.441,0-2.7s-.123-3.107,0-4.088,0-6.7,0-6.7.485-8.854.491-8.907.609-3.3.609-3.3l1.2-3.84-1.2-6.209s-3.968-4.068-5.638-.307c-.457,1.029-1.25,2.323-1.455,11.217C807.976,553.971,807.437,560.72,807.5,560.883Z",
    transform: "translate(-799.902 -506.73)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1879",
    "data-name": "Path 1879",
    d: "M-1382.868,5791.518l-3.316.48-1.547-1.1v-.186l.24-.408,3.041.409,1.76.126Z",
    transform: "translate(1402.71 -5733.577)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1875",
    "data-name": "Path 1875",
    d: "M-1372.295,5791.7l-1.973,1.991-8.63-1.378-4.714-1.373v-.233l-.12-.528,10.114.529,5.36.159Z",
    transform: "translate(1395.16 -5753.429)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1865",
    "data-name": "Path 1865",
    d: "M640.376,213.22s8.341-5.088,8.538-5.874l3.766,5.747,1.06-3.046s3.227,3.191,3.227,4.566.2,5.5-.393,6.678,1.768,16.106,1.768,16.106-1.964,1.768-2.161,1.964-8.053-1.178-8.053-1.178-5.182-.2-5.182-.786.849-8.078.456-10.435c-.3-1.822.4-9.185,0-12.349C643.3,213.795,640.376,213.22,640.376,213.22Z",
    transform: "translate(-635.087 -196.552)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2069",
    "data-name": "Path 2069",
    d: "M89.432,88.634h.422l-.589,4.431s-.153.846.443,1.143,2.427.982,2.427.982l6.307,1.78a7.442,7.442,0,0,1,3.126,0,7.261,7.261,0,0,1,2.178,1.135c.184.246-.844.431-.844.431l-5.813-.431-8.957-2.438-.752-5.454Z",
    transform: "translate(-80.235 -66.003)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1871",
    "data-name": "Path 1871",
    d: "M611.8,289.52s-.982,12.767.393,13.159,6.285,3.339,14.141,2.553c0,0,7.66,4.125,6.482.2s-6.482-2.946-6.482-2.946-9.428-1.964-9.82-3.339,1.178-7.071.589-7.267S611.8,289.52,611.8,289.52Z",
    transform: "translate(-607.547 -270.904)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1867",
    "data-name": "Path 1867",
    d: "M737.606,245.665l-3.142-.393s-3.143,6.089-1.375,7.071,6.285,1.768,6.285,1.375S737.606,245.665,737.606,245.665Z",
    transform: "translate(-727.971 -230.29)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1878",
    "data-name": "Path 1878",
    d: "M-1382.49,5788.84l.012,1.755-3.493-1.264-1.547-1.1-.214-.187.214-.786,3.281.786,1.76.128Z",
    transform: "translate(1395.642 -5730.882)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_560",
    "data-name": "Ellipse 560",
    cx: 4.714,
    cy: 4.714,
    r: 4.714,
    transform: "translate(13.213 1.366)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1872",
    "data-name": "Path 1872",
    d: "M651.672,124.225a3.318,3.318,0,0,0-2.012-.157,6,6,0,0,0-2.268,1.758,2.7,2.7,0,0,1-2.583.955,1.514,1.514,0,0,0-.289-1.119,1.029,1.029,0,0,1-.257-.428c-.039-.252.173-.47.237-.718.112-.434-.194-1.027.182-1.27.1-.064.225-.079.322-.146.38-.266-.042-.927.209-1.316a.8.8,0,0,1,.286-.238c1.823-1.063,4.051-1.066,6.161-1.04.294,0,.7.15.62.431.4-.286.921.116,1.242.487l.658.759a5.844,5.844,0,0,1,.8,1.088c.2.384.245.975-.155,1.143.3-.125.658,1.637-.713,1.347C653.319,125.593,652.538,124.534,651.672,124.225Z",
    transform: "translate(-631.757 -120.5)",
    fill: "#2f2e41"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobSearch);
export default __webpack_public_path__ + "static/media/JobSearch.cf6231c51d36a35c980104c0d67fc868.svg";
export { ForwardRef as ReactComponent };